import styled from "@emotion/styled";

export const DeleteNotificationFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;
